import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AJSCatalogsService } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from '../core/alcmeon-context/alcmeon-context.service';
import { API_URL_PREFIX } from '../shared/services/basic.service';
import { ErrorHandlingService } from '../shared/services/error-handling.service';

const urlPrefix = `${API_URL_PREFIX}/api/1.0/companies`;

@Injectable({
  providedIn: 'root',
})
export class CatalogsService {
  constructor(
    private http: HttpClient,
    private alcmeonContextService: AlcmeonContextService,
    private ajsCatalogsService: AJSCatalogsService,
    private ehs: ErrorHandlingService
  ) {}

  getConnectedBusinessManagers() {
    const url = `${API_URL_PREFIX}/api/1.0/companies/${this.alcmeonContextService.companyId}/business-managers`;
    return this.http.get<any>(url);
  }

  goToCatalogs() {
    this.ajsCatalogsService.goToCatalogs();
  }

  connectCatalogs(catalogIdsToBeConnected, businessId, authorizationId) {
    const data = {
      authorization_id: authorizationId,
      catalog_ids: catalogIdsToBeConnected || [],
    };
    const url = `${urlPrefix}/${this.alcmeonContextService.companyId}/business-manager/${businessId}/add-catalog/select`;
    return this.http.post<any>(url, data).pipe(this.ehs.catchAlertAndThrowHttpError());
  }

  disconnectCatalog(businessId, catalogId) {
    const url = `${urlPrefix}/${this.alcmeonContextService.companyId}/business-manager/${businessId}/remove-catalog/${catalogId}`;
    return this.http.post<any>(url, {}).pipe(this.ehs.catchAlertAndThrowHttpError());
  }
}
